export class ApiError extends Error {
  constructor(public status: number, public payload: unknown, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const hasBody = body !== undefined;
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers: hasBody ? { 'Content-Type': 'application/json' } : {},
    body: hasBody ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let payload: unknown = null;
    try { payload = await res.json(); } catch { /* not json */ }
    const msg = (payload as { error?: string } | null)?.error ?? `HTTP ${res.status}`;
    if (res.status === 403 && msg === 'unknown_or_inactive_user') {
      await fetch('/auth/logout', { method: 'POST', credentials: 'include' }).catch(() => {});
      window.location.replace('/?deactivated=1');
      return new Promise<T>(() => {});
    }
    throw new ApiError(res.status, payload, msg);
  }
  if (res.status === 204) return null as T;
  return (await res.json()) as T;
}

export const apiGet = <T>(path: string): Promise<T> => request<T>('GET', path);
export const apiPost = <T>(path: string, body: unknown): Promise<T> => request<T>('POST', path, body);
export const apiPatch = <T>(path: string, body: unknown): Promise<T> => request<T>('PATCH', path, body);
export const apiDelete = <T>(path: string): Promise<T> => request<T>('DELETE', path);
